import axios from "axios";
import { useEffect, useState } from "react";
import { apibasePath } from "../config";
const CartFilter = ({ id }) => {
  const [stock, setStock] = useState([]);

  const Token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchData = async (id) => {
      try {
        let response = await axios.get(
          `${apibasePath}/client/cart-details/${id}`,
          {
            headers: {
              Authorization: `bearer ${Token}`,
              "Content-Type": "application/json",
            },
          },
        );
        console.log("responnnsnsnn", response);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <table>
        <thead>
          <tr style={{ color: "#35646E" }}>
            <th></th>
            <th>Customer Code</th>
            <th>Quantity</th>
            <th>Gross Weight</th>
            <th>Stone Weight</th>
            <th>Net Weight</th>
          </tr>
        </thead>
        <tbody>
          {stock.map((item) => (
            <tr style={{ color: "#35646E" }}>
              <td>{item.customer_code}</td>
              <td>{item.total_quantity}</td>
              <td>{item.total_gross_weight}</td>
              <td>{item.total_stone_weight}</td>
              <td>{item.total_net_weight}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CartFilter;
